export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/bing.2520298.svg";